<template>
  <section class="bg-white grid place-items-center h-[100dvh] md:h-screen">
    <div class="px-2 sm:px-6 lg:px-8 max-w-7xl">
      <div class="max-w-[500px] mx-auto">
        <div>
          <div class="forny-form">
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item"></li>
            </ul>
            <img
              class="w-auto h-20 mx-auto"
              src="/assets/img/uac-logo.png"
              alt="Logo"
            />
            <h1
              class="mt-[16px] mb-[8px] text-[20px] sm:text-[24px] font-bold text-black"
            >
              Change Password
            </h1>
            <p
              class="text-[16px] sm:text-[18px] leading-[21.78px] text-[#81868c] mb-[20px] font-normal"
            >
              Please change your password to continue.
            </p>
            <form>
              <div>
                <input
                  :class="[
                    { 'is-invalid': passwordValidation.password },
                    { 'is-invalid': passwordValidation.newValid },
                  ]"
                  type="password"
                  class="w-full px-[16px] py-[12px] text-[14px] placeholder-gray-[#81868c] border-[0.5px] border-[rgba(0, 0, 0, 0.3)] outline-none rounded-[8px]"
                  placeholder="New Password"
                  v-model="user.password"
                />
                <ul
                  v-if="passwordValidation.password"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required text-danger">Required.</li>
                </ul>
                <ul
                  v-if="passwordValidation.newValid"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required text-danger">
                    Enter greater than or equal to 6 characters.
                  </li>
                </ul>
              </div>

              <div>
                <input
                  :class="[
                    { 'is-invalid': passwordValidation.confirmPassword },
                    { 'is-invalid': passwordValidation.confirmValid },
                  ]"
                  type="password"
                  class="w-full px-[16px] py-[12px] text-[14px] placeholder-gray-[#81868c] border-[0.5px] border-[rgba(0, 0, 0, 0.3)] outline-none rounded-[8px] my-[16px]"
                  placeholder="Confirm Password"
                  v-model="user.confirmPassword"
                />
                <ul
                  v-if="passwordValidation.confirmPassword"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required text-danger">Required.</li>
                </ul>
                <ul
                  v-if="passwordValidation.confirmValid"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required text-danger">
                    Passwords do not match.
                  </li>
                </ul>
              </div>

              <div>
                <button
                  :disabled="isBusy"
                  class="w-full px-6 py-[12px] text-lg font-normal leading-5 text-white transition-all duration-200 bg-[#2463EB] border border-solid border-[#2463EB] outline-none focus-none rounded-[8px] disabled:opacity-50 mb-[16px]"
                  @click.prevent="changePassword"
                >
                  <i class="feather icon-lock"></i> &nbsp;
                  <span v-if="isBusy">Busy...</span>
                  <span v-else>Change password</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */

import { helper } from "@/helper";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "changePassword",
  data() {
    return {
      isBusy: false,
      user: {
        emailAddress: "",
        password: "",
        confirmPassword: "",
      },
      passwordValidation: {
        password: false,
        confirmPassword: false,
        newValid: false,
        confirmValid: false,
      },
    };
  },
  validations: {
    user: {
      password: { required },
      confirmPassword: { required },
    },
  },
  methods: {
    async changePassword() {
      this.$v.$touch();

      if (this.validatePassword()) {
        this.isBusy = true;

        let data = {
          id: this.$store.state.userId,
          password: this.user.password,
          confirmPassword: this.user.confirmPassword,
        };

        await this.$http
          .post("/Auth/changePassword", data)
          .then(function(res) {
            $.gritter.add({
              title: "Password change successful",
              text:
                "Your password has been changed successfully. Please login to continue.",
              class_name: "color success",
            });

            this.$router.push("/login");
          })
          .catch(function() {});

        this.isBusy = false;
      }
    },
    validatePassword() {
      this.passwordValidation = {
        password: false,
        confirmPassword: false,
        newValid: false,
        confirmValid: false,
      };
      let isValid = true;

      if (!this.user.password) {
        this.passwordValidation.password = true;
        isValid = false;
      }

      if (!this.user.confirmPassword) {
        this.passwordValidation.confirmPassword = true;
        isValid = false;
      }

      if (this.user.password && !helper.validateLength(this.user.password, 6)) {
        this.passwordValidation.newValid = true;
        isValid = false;
      }

      if (this.user.password !== this.user.confirmPassword) {
        this.passwordValidation.confirmValid = true;
        isValid = false;
      }

      return isValid;
    },
  },
};
</script>
